import Order from '../service/order'
import RequestUtils from '../../store/requestUtils'
export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    // 发货
    downloaddeliverypendings(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Order.downloaddeliverypendings(payload), {
        type: 'file',
        success,
        fail
      })
    },
    downloaddeliveryordertemplate(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Order.downloaddeliveryordertemplate(payload), {
        type: 'file',
        success,
        fail
      })
    },
    deliverorders(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Order.deliverorders(payload), {
        type: 'action',
        success,
        fail
      })
    },
    getdeliverypendings(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Order.getdeliverypendings(payload), {
        type: 'list',
        success,
        fail
      })
    },
    getindeliverys(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Order.getindeliverys(payload), {
        type: 'list',
        success,
        fail
      })
    },
    getexpresses(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Order.getexpresses(payload), {
        type: 'list',
        success,
        fail
      })
    },
    deliverorder(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Order.deliverorder(payload), {
        type: 'action',
        success,
        fail
      })
    },
    // 全部订单
    getorders(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Order.getorders(payload), {
        type: 'list',
        success,
        fail
      })
    },
    closeorder(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Order.closeorder(payload), {
        type: 'action',
        success,
        fail
      })
    },
    // 退款/退货列表
    getorderreturns(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Order.getorderreturns(payload), {
        type: 'list',
        success,
        fail
      })
    },
    ackorderreturn(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Order.ackorderreturn(payload), {
        type: 'action',
        success,
        fail
      })
    },
    agreeorderreturn(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Order.agreeorderreturn(payload), {
        type: 'action',
        success,
        fail
      })
    },
    // 全部订单
    getorder(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Order.getorder(payload), {
        type: 'info',
        success,
        fail
      })
    },
    getorderdeliverytrace(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Order.getorderdeliverytrace(payload), {
        type: 'list',
        success,
        fail
      })
    }
  }
}
